import axios from 'axios';
export let httpAxios = axios.create({
	headers: {
		'Content-Type': 'application/json;charset=utf-8'
	}
});
export default function ajaxJson(url, data = {}, type = 'GET', isJson = true) {
	return new Promise((resolve, reject) => {
		if (isJson == true) {
			httpAxios({
				method: type,
				url: url,
				data: type === 'POST' || type === 'PUT' ? data : null,
				params: type === 'GET' || type === 'DELETE' ? data : null
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			});
		} else {
			httpAxios({
				headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
				method: type,
				url: url,
				data: type === 'POST' || type === 'PUT' ? data : null,
				params: type === 'GET' || type === 'DELETE' ? data : null
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			});
		}
	});
};


// WEBPACK FOOTER //
// ./src/api/ajax.js